import React, { lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { retry } from "../common/utils/commonFunction";
import creatorRoutes from "./CreatorRoutes";
import brandRoutes from "./BrandRoutes";

const LandingPage = lazy(() => retry(() => import("../pages/LandingPage")));
const RegisterTypePage = lazy(() =>
  retry(() => import("../pages/auth/RegisterTypePage"))
);
const BrandRegister = lazy(() =>
  retry(() => import("../pages/auth/BrandRegister"))
);
const CreatorRegister = lazy(() =>
  retry(() => import("../pages/auth/CreatorRegister"))
);
const FourOhFour = lazy(() => retry(() => import("../pages/FourOhFour")));

const Routes = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <LandingPage />,
    },
    {
      path: "/register",
      element: <RegisterTypePage />,
    },
    {
      path: "/register/brand",
      element: <BrandRegister />,
    },
    {
      path: "/register/creator",
      element: <CreatorRegister />,
    },
    ...creatorRoutes,
    ...brandRoutes,
    {
      path: "/*",
      element: <Navigate replace to="/404" />,
    },
    {
      path: "/404",
      element: <FourOhFour isAdmin={false} />,
    },
  ]);

  return routes;
};

export default Routes;
